// extracted by mini-css-extract-plugin
export const modalContainer = "modal-module--modal-container--1p3p8";
export const modalFrame = "modal-module--modal-frame--OkIf1";
export const modalBackdrop = "modal-module--modal-backdrop--1_xy-";
export const active = "modal-module--active--3vCR9";